
<template>
    <div class="text-md-subtitle-2 rounded pa-2 text-white d-inline-block" :class="statusClass">
        <i class="fa-solid" :class="iconClass"></i>
        <span class="px-1">{{ $t(status) }}</span>
    </div>
</template>
<script>
    export default {
        props: {
            status: {
                type: String,
                required: true
            }
        },
        computed: {
            statusClass() {
                return (this.statusMap[this.status]?.class || 'status-default')
            },
            iconClass() {
                return (this.statusMap[this.status]?.icon || 'fas fa-question-circle')
            }
        },
        data() {
            return {
                statusMap: {
                    'In Progress': { class: 'bg-lime-lighten-1', icon: 'fa-hourglass text-yellow-darken-4' },
                    Checking: { class: 'bg-blue-darken-4', icon: 'fa-file-pen text-yellow-darken-4' },
                    Pending: { class: 'bg-orange-lighten-1', icon: 'fa-clock text-yellow-lighten-4' },
                    Cancel: { class: 'bg-blue-darken-1', icon: 'fa-ban text-yellow-darken-4' },
                    Canceled: { class: 'bg-blue-darken-1', icon: 'fa-ban text-yellow-darken-4' },
                    Rejected: { class: 'bg-red-darken-4', icon: 'fa-file-pen text-red-darken-4' },
                    Evaluated: { class: 'bg-amber-lighten-1', icon: 'fa-hourglass text-yellow-darken-4' },
                    Checked: { class: 'bg-green-lighten-1', icon: 'fa-circle-check text-green-darken-4' },
                    Completed: { class: 'bg-green-lighten-1', icon: 'fa-circle-check text-green-darken-4' },
                    Approve: { class: 'bg-green-lighten-1', icon: 'fa-circle-check text-green-darken-4' },
                }
            }
        }
    }
</script>
